const langDocumentFilesTable = {
	document_name: {
		tag: 'document.files.table.document_name',
		fr: 'Nom du document',
		en: 'Document name',
	},
	document_type: {
		tag: 'document.files.table.document_type',
		fr: 'Type de document',
		en: 'Document type',
	},
	subportfolio: {
		tag: 'document.files.table.subportfolio',
		fr: 'Canton',
		en: 'Subportfolio',
	},
	fund_type: {
		tag: 'document.files.table.fund_type',
		fr: 'Type de fonds / mandat',
		en: 'Funds / Mandate type',
	},
	release_date: {
		tag: 'document.files.table.release_date',
		fr: 'Date de diffusion',
		en: 'Release date',
	},
	download: {
		tag: 'document.files.table.download',
		fr: 'Télécharger',
		en: 'Download',
	},
	view: {
		tag: 'document.files.table.view',
		fr: 'Détail',
		en: 'Detail',
	},
	fund: {
		tag: 'document.files.table.fund',
		fr: 'Nom du fonds / mandat',
		en: 'Fund / Mandate name',
	},
};

export default langDocumentFilesTable;
